<template>
  <AppPageFrame showHeader>
    <OffersCategory class="p-5" title="Recommended Resources" description="Here are some helpful resources based on your interests and needs." :offers="offers" context="offers/all"/>
  </AppPageFrame>

</template>

<script lang="ts" setup>

import OffersCategory from '@/features/partnerOffers/OffersCategory.vue';
import { onMounted, ref } from 'vue';
import { getOffers, logImpressions } from '@/features/partnerOffers/api';
import { PartnerOffer } from '@/features/partnerOffers/model';

const offers = ref<PartnerOffer[]>([]);

onMounted(() => {
  getOffers().
    then(allOffers => {
      offers.value = allOffers;

      logImpressions("offers/all", allOffers);
    });
});

</script>

<style scoped>
</style>
